import { render, staticRenderFns } from "./InvoiceDetailsSection.vue?vue&type=template&id=f831f32a&scoped=true"
import script from "./InvoiceDetailsSection.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsSection.vue?vue&type=style&index=0&id=f831f32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f831f32a",
  null
  
)

export default component.exports